import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { HeaderEnum } from "./constant";
const ToolsContent = (props) => {
    const [index, setIndex] = useState(0);
    const hidenavTab = () => {
        props.setShowNav(() => !props.showNav);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Row, { className: "mx-0 header-link-section pt-30" },
            React.createElement(Col, { lg: 12, className: "grid-2 gap-30" },
                React.createElement("ul", { className: "header-link-content ps-0 pb-0" },
                    React.createElement("li", null,
                        React.createElement(Link, { to: HeaderEnum.OPTIONS_CHAIN_TOOL, onClick: () => {
                                hidenavTab();
                            } }, "Options Chain")),
                    React.createElement("li", null,
                        React.createElement(Link, { to: HeaderEnum.OPTION_CHAIN_INSIDER_SAST, onClick: () => {
                                hidenavTab();
                            } }, "Deals, Insider SAST")),
                    React.createElement("li", null,
                        React.createElement(Link, { to: HeaderEnum.OPTION_CHAIN_MARGIN_CALCULATOR, onClick: () => {
                                hidenavTab();
                            } }, "Margin Calculator")),
                    React.createElement("li", null,
                        React.createElement(Link, { to: HeaderEnum.OPTION_CHAIN_EVENT_CALENDAR, onClick: () => {
                                hidenavTab();
                            } }, "Events Calendar"))),
                React.createElement("ul", { className: "header-link-content pb-0" },
                    React.createElement("li", null,
                        React.createElement(Link, { to: HeaderEnum.ALERTS, onClick: () => {
                                hidenavTab();
                            } }, "Alerts")),
                    React.createElement("li", null,
                        React.createElement(Link, { to: HeaderEnum.ALERTS_TRADING_AREA, onClick: () => {
                                hidenavTab();
                            } }, "Trading Area")),
                    React.createElement("li", null,
                        React.createElement(Link, { to: HeaderEnum.ALERTS_LIVE_NEWS, onClick: () => {
                                hidenavTab();
                            } }, "Live News")),
                    React.createElement("li", null,
                        React.createElement(Link, { to: HeaderEnum.ALERTS_ALPHA, onClick: () => {
                                hidenavTab();
                            } }, "Alpha Alerts")))))));
};
export default ToolsContent;
